import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Router, ActivatedRoute} from '@angular/router';
import {ApiService, MessagesService} from '@angular/synthrone-design/services';
import {APP_CONFIG} from '@synthroneApp/app.config';
import {MatDialog} from '@angular/material';
import {ComponentModel} from '@synthroneApp/models/component/component.model';
import {AlertComponent} from "@angular/synthrone-design/components";
import {ComponentVariantFormComponent} from "@synthroneApp/components/forms/component-variant-form/component-variant-form.component";

@Component({
    selector: 'app-component-variants-view',
    templateUrl: './component-variants-view.component.html',
    styleUrls: ['./component-variants-view.component.scss']
})

export class ComponentVariantsViewComponent implements OnInit {

    dataId: number;
    isLoading = true;
    variants: any;

    @ViewChild('table') table;

    configColumns = {
        name: {
            label: 'Name',
            sortable: true,
            truncate: true
        },
        slug: {
            label: 'Slug',
            sortable: true,
            truncate: true
        }
    };

    constructor(private _router: Router, private route: ActivatedRoute, protected api: ApiService,
                private messagesService: MessagesService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog) {
    }

    ngOnInit() {
        this.dataId = parseInt((this._router.url).match(/\d+/)[0]);
    }

    homeReturnFN = () => {
        this._router.navigate(['/components/edit', this.dataId, 'variants']);
    };

    submitFN(isValid: boolean) {
        this.isLoading = true;

        this.api.makeRequest('api_system_component_edit', this.variants, 'crafter').subscribe( // fix route with component ID
            (result) => {
                this.isLoading = false;
                this.homeReturnFN();
            },
            (error) => {
                this.isLoading = false;
                this.messagesService.showSnack(error, 'error');
            });
    }

    add = () => {
        this.dialog.open(ComponentVariantFormComponent, {
            width: '700px',
            data: {
                callback: (parsed) => {
                    const v = Object.assign({}, parsed, {
                        component: this.dataId
                    });
                    return this.api.makeRequest('api_system_variant_add', v, 'crafter');
                }
            },
            panelClass: 'no-padding-container'
        }).afterClosed().subscribe(
            (result) => {
                if (result != null) {
                    this.table.getData();
                }
            });
    };

    editRow = (key) => {
        this.dialog.open(ComponentVariantFormComponent, {
            width: '700px',
            data: {
                dataId: key,
                callback: (parsed) => {
                    const v = Object.assign({}, parsed, {
                        component: this.dataId
                    });
                    return this.api.makeRequest('api_system_variant_edit', v, 'crafter');
                }
            },
            panelClass: 'no-padding-container'
        }).afterClosed().subscribe(
            (result) => {
                if (result != null) {
                    this.table.getData();
                }
            });
    };

    deleteRow = (key) => {
        let dialogRef = this.dialog.open(AlertComponent, {
            data: {
                message: 'Are you sure that you want to delete this variant?'
            }
        }).afterClosed().subscribe(result => {
            if (result == 'proceed') {
                this.api.makeRequest('api_system_variant_delete', {
                    id: key
                }, 'crafter').subscribe(
                    (result) => {
                        this.table.getData();
                    },
                    (error) => {
                        this.messagesService.showSnack(error, 'error');
                    }
                );
            }
        });
    };

    getTableData = (limit, offset, sortBy, sortOrder): Observable<any> => {
        return this.api.makeRequest('api_system_component_variants_list', {
            id: this.dataId,
            seed: new Date().getTime(),
            offset: offset,
            limit: limit,
            sortBy: sortBy,
            sortOrder: sortOrder
        }, 'crafter');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/views/component-variants-view/component-variants-view.component.ts